import script from "./SettingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsView.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsView.vue?vue&type=style&index=0&id=48f0114e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f0114e"]])

export default __exports__